<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("shipping") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <router-link to="/backoffice/packings">
                        <base-button size="md" type="neutral">{{
                            $t("back")
                        }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-3 packing-col-left">
                <div>
                    <card
                        header-classes="bg-transparent"
                        footer-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class=" border-0  mb-4"
                    >
                        <template slot="header">
                            <!-- Select storage_id , shipping -->
                            <div class="form-group row">
                                <div class="col-12">
                                    <base-input
                                        :label="$t('wms.menu.inventory')"
                                    >
                                        <el-select
                                            v-model="params.storage_id"
                                            :label="$t('wms.menu.inventory')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in StorageTable"
                                                :key="option.ID"
                                                :label="option.Name"
                                                :value="option.ID"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <!-- <div class="col-md-6">
									<base-input :label="$t('shipping_provider')" >
										<el-select v-model=" params.shipping_provider_id " :label="$t('shipping_provider')"  :disabled="lock">
											<el-option v-for="option in ShippingProviderTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
										</el-select>
									</base-input>
								</div> -->

                                <div class="col-12">
                                    <base-input :label="$t('platform')">
                                        <el-select
                                            v-model="params.platform_id"
                                            :label="$t('platform')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in PlatformTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <!-- Lock -->
                                <div class="col-12 py-4">
                                    <base-button
                                        @click="handleUnLock"
                                        v-if="lock"
                                        >UnLock</base-button
                                    >

                                    <!-- Unlock -->
                                    <base-button
                                        @click="handleLock"
                                        v-if="!lock"
                                        >Lock</base-button
                                    >
                                </div>
                            </div>
                        </template>

                        <div class="row" v-if="lock">
                            <div class="col-md-12">
                                <base-input :label="$t('barcode_type')">
                                    <el-select
                                        v-model="barcode_type"
                                        :placeholder="$t('barcode_type')"
                                        class="w-100"
                                    >
                                        <el-option
                                            :label="$t('barcode_type_tracking')"
                                            value="tracking_number"
                                        ></el-option>
                                        <el-option
                                            :label="$t('barcode_type_platform_order_id')"
                                            value="platform_order_id"
                                        ></el-option>
                                    </el-select>
                                </base-input>
                            </div>
                            <div class="col-md-12">
                                <base-input
                                    :placeholder="$t('scanbarcode')"
                                    v-model="barcode"
                                    class="form-control-alternative"
                                    prepend-icon="ni ni-zoom-split-in"
                                    v-on:keyup.enter="handleBarcode"
                                ></base-input>
                            </div>
                            <div class="col-md-12" v-if="isWait">
                                <span>
                                    <i class="fas fa-spinner fa-spin"></i>
                                    กำลังประมวลผล...</span
                                >
                            </div>
                        </div>

                        <!-- Show Order ID -->
                    </card>
                </div>
            </div>

            <div class="container-fluid mt--6 col-lg-9 packing-col-right">
                <div>
                    <!-- card right -->
                    <card
                        class="no-border-card"
                        body-classes="px-lg-4 py-lg-3"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <div
                                    class="col-md-10 col-form-label form-control-label"
                                >
                                    <h3
                                        class="mb-0"
                                        v-if="params.id == '' || params.id == 0"
                                    >
                                        {{ $t("order_information") }}
                                    </h3>
                                    <h3 class="mb-0" v-else>
                                        {{ $t("order_information") }} :
                                        {{ this.params.id }}

										<template v-if="params.tracking_number != ''">
											- Tracking Number : {{ this.params.tracking_number }}
										</template>
                                    </h3>


                                </div>
								<div class="col-md-2 text-right">
									<base-button @click="handleClear">Clear</base-button>
								</div>

                            </div>
                        </template>
                        <!-- Selected Product -->
                        <div
                            v-if="allScanned(order_items)"
                            class="packing-all-scanned text-success font-weight-bold"
                            data-testid="packing-all-scanned"
                        >
                            <i class="fa fa-check-circle"></i>
                            {{ $t("packing_all_scanned") }}
                        </div>
                        <div class="row">
                            <div
                                class="col-lg-3 col-md-4 col-6 d-flex"
                                v-for="o in order_items"
                                :key="o.id"
                            >
                                <div class="card w-100 mb-3 packing-item" :class="scannedCardClass(o)">
                                    <img
                                        class="card-img-top packing-item__img"
                                        :src="GetProductImage(o.wms_product_id)"
                                    />
                                    <div class="card-body d-flex flex-column">
                                        <h5 class="packing-item__name mb-1">
                                            <span
                                                class="text-green"
                                                v-if="o.pickup_need == null"
                                            >
                                                {{ o.wms_product_name }}
                                            </span>
                                            <span v-else>
                                                {{ o.wms_product_name }}
                                            </span>
                                            (
                                            <span
                                                class="text-green"
                                                >{{
                                                        o.pickup_quantity
                                                }}
                                            </span>
                                           
                                            )
                                        </h5>

                                        <div
                                            class="px-0 mt-auto packing-item__barcode text-green"
                                            v-if="o.pickup_need == null"
                                        >
                                            {{ o.barcode }}
                                        </div>
                                        <div class="px-0 mt-auto packing-item__barcode" v-else>
                                            {{ o.barcode }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>

        <!--  Modal -->
        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                Loading...
            </form>

            <template slot="footer"> </template>
        </modal>
    </div>
</template>
<script>
import { shippingFormProviders } from "@/const/shippingProviders";
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { allScanned, scannedCardClass } from "@/utils/packingScan";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            StorageTableOrg: "WmsStorage/getData",
            // #416 ruling: packing / return rooms verify order contents (barcode + image); old
            // orders with a disabled product must still pack, so this reads the active=all list.
            ProductTable: "WmsProduct/getDataAll",
            PlatformTable: "Order/getPlatformTable"
        }),

        StorageTable() {
            return this.StorageTableOrg.filter(item => {
                return item.ID != 1;
            });
        }
    },
    data() {
        return {
            isLoading: false,
            showModal: false,
            lock: false,
            isWait: false,
            // mdf-bo-fn#237: the list lives in src/const/shippingProviders.js,
            // mirrored from the back-end table. This page used to carry its own
            // copy with id 5 = มาดามฟิน; the back-end says 5 = DHL, 6 = มาดามฟิน.
            ShippingProviderTable: shippingFormProviders(),

            state: 0,
            barcode: "",
            // What `barcode` represents when scanned. "tracking_number" (default)
            // searches bo_orders.shipping_tracking_number; "platform_order_id"
            // searches bo_orders.platform_order_id. Mirrors ShippingFormByLine.
            barcode_type: "tracking_number",
            first_barcode: "",
            pickup_items: [], // สินค้าที่หยิบใส่กล่องแล้ว
            order_items: [], // สินค้าที่เลือกจาก Order

            params: {
                id: 7,
                shipping_provider_id: 0,
                tracking_number: "",
                storage_id: "",
                barcode: "",
                platform_id: 1
            },

            propsToSearch: []
        };
    },
    mounted() {
        this.listStorage();
        this.listProduct({ active: "all" });
        this.clearParam();
    },
    methods: {
        allScanned,
        scannedCardClass,
        ...mapActions({
            listSaleChannel: "SaleChannel/listData",
            listStorage: "WmsStorage/listData",
            listProduct: "WmsProduct/listData",
            addItem: "Packing/AdminAddPickupItem",
            clearItem: "Packing/AdminClearPickupItem",
            closeOrder: "Packing/AdminCloseShippingOrder"
        }),

        async handleBarcode() {
            console.log("handleBarcode", this.barcode);
            console.log("state", this.state);
            this.showModal = true;

            this.params.barcode = this.barcode;
            this.barcode = "";

            // "MDFSP…" is a MadameFin SPX tracking number, NOT an order ID —
            // strip-the-prefix would leave us with a non-numeric stub that
            // parseInt turns into NaN, which the backend reads as id=0 and
            // rejects as "OrderGetEnterpriseID, record not found". Same
            // guard as ShippingFormByLine.vue.
            const isMDFSPTracking = this.params.barcode.startsWith("MDFSP");
            let isOrder = !isMDFSPTracking && this.params.barcode.startsWith("MDF");
            let orderId = isOrder ? this.params.barcode.replace("MDF", "") : this.params.barcode;

            if (this.isWait) {
                console.log("isLoading... , cancel this barcode");
                return;
            }

            // Fetch Order ID
            try {
                orderId = parseInt(orderId);
            } catch (error) {
                console.log("error", error);
                this.showModal = false;
                swal.fire({
                    title: error,
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }
            console.log("isOrder", isOrder);


            switch (this.state) {
                case 0: // Unknown Order
                    this.handleOpenByIDOrTracking(isOrder, orderId);
                    break;
                case 1: // Received orderId => เพิ่มสินค้า
                    if (isOrder) {
                        this.params.id = orderId;
                    } else {
                        let barcodeValid = this.isValidBarcode(); // Barcode สินค้า
                        if (!barcodeValid) {
                            if (this.params.platform_id != 1) { // barcode ไม่ใช่สินค้า และเป็น platform อื่น ๆ

								// Check first barcode is same barcode
								if (this.first_barcode == this.params.barcode){
									this.params.tracking_number = this.params.barcode
									this.showModal = false;
									this.handleClose();
								} else {
									this.handleOpenByIDOrTracking(isOrder, orderId);
								}
                            } else {
								// ไม่ใช่บาร์โค้ดสินค้า   มาดามฟิน  
								// if is tracking
								if (this.isValidTracking(this.params.barcode)) {
									this.params.tracking_number = this.params.barcode
									this.state = 3
									this.showModal = false;
									// handle Close
								} else {
									swal.fire({
										title: "หมายเลข Tracking ไม่ถูกต้อง",
										text: "",
										icon: "error",
										confirmButtonClass: "btn btn-danger btn-fill",
										buttonsStyling: false
									});
								}
							}
                            return;
                        } 
                    }

                    this.handleAdd(isOrder);

                    break;

                case 2: // สินค้าครบแล้ว ครบแล้ว

					//  Platform
					if (this.params.platform_id != 1) {
						// check bar code = firstbarcode
						if (this.first_barcode == this.params.barcode) {
							console.log("handle close platform",this.first_barcode , this.params.barcode)
							this.params.tracking_number = this.params.barcode
							this.state = 3
							this.showModal = false;
							console.log("State 2 Recived Tracking Number" )
							return;
						} else {
							// check is product
							let barcodeValid = this.isValidBarcode(); // Barcode สินค้า
       		                if (barcodeValid) {
								this.showModal = false;
								swal.fire({
									title: "สินค้าถูกเพิ่มครบแล้ว",
									text: "",
									icon: "error",
									confirmButtonClass: "btn btn-danger btn-fill",
									buttonsStyling: false
								});
								return;
							}

							console.log("State 2 handleOpenByIDOrTracking" )
							this.handleOpenByIDOrTracking(isOrder, orderId);



						}
					} else {
						// Madamefin
						if (isOrder) {
							this.handleOpenByID(orderId);
							return;
						}

						this.showModal = false;
						// Check is product barcode
						let barcodeValid = this.isValidBarcode();
						if (barcodeValid) {
							swal.fire({
								title: "กรุณาระบุ Tracking No.",
								text: "",
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							return;
						}

						if (this.params.platform_id == 1 && !this.isValidTracking(this.params.barcode)) {
							swal.fire({
								title: "หมายเลข Tracking ไม่ถูกต้อง",
								text: "",
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							return;
						}

						this.state = 3
						this.params.tracking_number = this.params.barcode
						console.log("State 2 Recived Tracking Number" )
					}
                    break;
				case 3: // Received Tracking Number
					if (isOrder) {
						this.handleOpenByID(orderId);
						return;
					}

					this.showModal = false;

					if (this.params.barcode != "CLOSEORDERMDF")
					{
						swal.fire({
							title: "กรุณาระบุ Barcode ปิดการแพ็คสินค้า",
							text: "",
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
						return;
					}

					console.log("State 3 Recived 'CLOSEORDERMDF'" )
					this.handleClose();
				break;
            }
        },
		isValidTracking(barcode){
			// Check Tracking valid
			let tName = "";
			var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
			var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
			var regIsKerryMFIN = /^MFIN[0-9A-F]{10}$/gi;
			var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;
			var regIsKerryShopee = /^SD[A-Z]{2}\d{10}$/gi;
			var regIsDHL = /^[A-Z]{5}\d{10}$/gi;
			var regIsFlash = /^TH[0-9A-Z]{12,13}$/gi;
			var regIsJT = /^[0-9]{12}$/gi;
			var regIsSPX = /^SPX[0-9A-Z]{12,14}$/gi;

			if (regIsThaipost.test(this.params.barcode)) {
				tName = "ไปรษณีย์ไทย";
			} else if (regIsKerry.test(this.params.barcode)) {
				tName = "Kerry";
			} else if (regIsKerryMFIN.test(this.params.barcode)) {
				tName = "Kerry";
			} else if (regIsKerryLazada.test(this.params.barcode)) {
				tName = "Kerry";
			} else if (regIsKerryShopee.test(this.params.barcode)) {
				tName = "Kerry";
			} else if (regIsDHL.test(this.params.barcode)) {
				tName = "DHL";
			} else if (regIsFlash.test(this.params.barcode)) {
				tName = "Flash";
			} else if (regIsJT.test(this.params.barcode)) {
				tName = "J&T";
			} else if (regIsSPX.test(this.params.barcode)) {
				tName = "SPX";
			}
			return tName != ""
		},
        async handleOpenByIDOrTracking(isOrder, orderId) {

            let resp = {};
            if (isOrder || this.params.platform_id != 1) {
                this.isWait = true;

				if (this.params.platform_id !=1){
					this.first_barcode = this.params.barcode
				}

                try {
                    resp = await this.addItem({
                        id: this.params.platform_id == 1 ? orderId : 0,
                        storage_id: this.params.storage_id,
                        barcode: this.params.platform_id == 1 ? "" : this.params.barcode,
                        barcode_type: this.barcode_type,
						platform_id: this.params.platform_id
                    });
                    this.isWait = false;
					if (resp.data.Datum.order_items == null){
						resp.data.Datum.order_items = []
					}
                } catch (err) {
                    console.log(err);
                    this.showModal = false;
                    this.isWait = false;

                    if ( err.response.data.Cause == "InventoryGetIDByProductIDStorageID, record not found") 
					{
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: "ไม่พบสินค้าในคลัง",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                        return false;
                    }

                    swal.fire({
                        title: this.$t(err.response.data.Msg),
                        text: err.response.data.Cause,
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });

                    return false;
                }

                // Check Product availabel all
                if (resp.data.Datum.all_available == false) {
                    let product = "";
                    resp.data.Datum.order_items.forEach(e => {
                        if (e.available == false) {
                            if (product == "") {
                                product = e.wms_product_name;
                            } else {
                                product = "," + e.wms_product_name;
                            }
                        }
                    });

                    swal.fire({
                        title: this.$t("errors.inventory_not_found"),
                        text: product,
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });

                    return true;
                }

                this.pickup_items = resp.data.Datum.pickup_items;
                this.order_items = resp.data.Datum.order_items;
                // mdf-bo-fn#237: the summary opens on the order's current carrier;
                // show it selected, and let the user change it before closing.
                this.params.shipping_provider_id = resp.data.Datum.shipping_provider_id || 0;

                if (this.params.platform_id == 1) {
                    this.params.id = orderId;
                } else {
                    this.params.id = resp.data.Datum.id;
                }

                // if (this.isOrderSuccess()) {
                //     this.state = 2;
                // } else {
				this.state = 1;
                // }
                this.barcode = "";
                this.showModal = false;
            } else {
                this.showModal = false;
				this.isWait = false;
                swal.fire({
                    title: "กรุณาสแกนหมายเลข Order",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            }
        },


        async handleOpenByID(orderId) {
            this.isWait = true;
            let resp = {};
            try {
                resp = await this.addItem({
                    id: orderId,
                    storage_id: this.params.storage_id,
                    barcode: ""
                });
                this.isWait = false;
            } catch (err) {
                console.log(err);
                this.showModal = false;
                this.isWait = false;
                swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err.response.data.Cause,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                return;
            }

            if (resp.data.Datum.all_available == false) {
                let product = "";
                resp.data.Datum.order_items.forEach(e => {
                    if (e.available == false) {
                        if (product == "") {
                            product = e.wms_product_name;
                        } else {
                            product = "," + e.wms_product_name;
                        }
                    }
                });

                swal.fire({
                    title: this.$t("errors.inventory_not_found"),
                    text: product,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                return;
            }

            this.pickup_items = resp.data.Datum.pickup_items;
            this.order_items = resp.data.Datum.order_items;
            this.params.id = orderId;

            if (this.isOrderSuccess()) {
                this.state = 2;
            } else {
                this.state = 1;
            }

			this.params.tracking_number = ""
            this.showModal = false;
        },
        handleClose() {

			let data = {
				id: this.params.id,
				shipping_provider_id: this.params.shipping_provider_id || 0, // mdf-bo-fn#237
				tracking_number: this.params.tracking_number
			};

			this.isWait = true;
			this.closeOrder(data)
			.then(resp => {
				swal.fire({
					title: "Success",
					text:
						"Order No." +
						this.params.id +
						" จัดส่งสำเร็จ",
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});
				this.clearParam();
				this.isWait = false;
			})
			.catch(err => {
				this.isWait = false;
				swal.fire({
					title: "Error",
					text: err.response.data.Cause,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});


			/*		
            this.showModal = false;
            let barcodeValid = this.isValidBarcode();
            if (barcodeValid) {
                this.showModal = false;
                swal.fire({
                    title: "กรุณาระบุ Tracking No.",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            let tName = "";
            var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
            var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
            var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;
            var regIsKerryShopee = /^SD[A-Z]{2}\d{10}$/gi;
            var regIsDHL = /^[A-Z]{5}\d{10}$/gi;
		
            if (regIsThaipost.test(this.params.barcode)) {
                tName = "ไปรษณีย์ไทย";
            } else if (regIsKerry.test(this.params.barcode)) {
                tName = "Kerry";
            } else if (regIsKerryLazada.test(this.params.barcode)) {
                tName = "Kerry";
            } else if (regIsKerryShopee.test(this.params.barcode)) {
                tName = "Kerry";
            } else if (regIsDHL.test(this.params.barcode)) {
                tName = "DHL";
            } else if (this.params.platform_id == 1) {
                swal.fire({
                    title: "หมายเลข Tracking ไม่ถูกต้อง",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            swal.fire({
                title:
                    "ยืนยันการจัดส่งสินค้า Order No." +
                    this.params.id +
                    " หรือไม่ ?",
                text: "Tracking No. " + this.params.barcode + `  (${tName})`,
                icon: "info",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    let data = {
                        id: this.params.id,
                        shipping_provider_id: this.params.shipping_provider_id || 0, // mdf-bo-fn#237: the user\'s choice
                        tracking_number: this.params.barcode
                    };

                    this.isWait = true;
                    this.closeOrder(data)
                        .then(resp => {
                            swal.fire({
                                title: "Success",
                                text:
                                    "Order No." +
                                    this.params.id +
                                    " จัดส่งสำเร็จ",
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                            this.clearParam();
                            this.isWait = false;
                        })
                        .catch(err => {
                            this.isWait = false;
                            swal.fire({
                                title: "Error",
                                text: err.response.data.Cause,
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
			*/
        },
		handleConfirmClose() {

		},
		async handleClear(){
			this.isWait = true;
			try {
				let resp = await this.clearItem({
					id: this.params.id,
                    storage_id: this.params.storage_id,
                    barcode:  "" ,
                    platform_id: this.params.platform_id
				});
				this.isWait = false
				this.order_items = []
				this.params.tracking_number = ""
				this.state = 1
				console.log("Clear Item" , resp)
				this.clearParam();
			}
			catch (err){
				this.isWait = false
				console.log("Clear Item error" , err)
				swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err.response.data.Cause,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			}
		},
        async handleAdd(isOrder) {
            this.isWait = true;
			let resp = {};
            try {
                resp = await this.addItem({
                    id: this.params.id,
                    storage_id: this.params.storage_id,
                    barcode: isOrder ? "" : this.params.barcode,
                    barcode_type: this.barcode_type,
                    platform_id: this.params.platform_id
                });
                this.isWait = false;
            } catch (err) {
                console.log(err);
                this.showModal = false;
                swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err.response.data.Cause,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                if (isOrder) {
                    this.clearParam();
                }
                this.isWait = false;
                return;
            }

            if (resp.data.Datum.all_available == false) {
                let product = "";
                resp.data.Datum.order_items.forEach(e => {
                    if (e.available == false) {
                        if (product == "") {
                            product = e.wms_product_name;
                        } else {
                            product = "," + e.wms_product_name;
                        }
                    }
                });

                swal.fire({
                    title: this.$t("errors.inventory_not_found"),
                    text: product,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

                return;
            }

            this.pickup_items = resp.data.Datum.pickup_items;
            this.order_items = resp.data.Datum.order_items;

            // if (this.isOrderSuccess()) {
            //     this.state = 2;
            // } else {
			this.state = 1;
            // }
            this.barcode = "";
            this.showModal = false;
        },

        isValidBarcode() {
            let isValid = false;
            if (this.params.barcode == "") {
                isValid = false;
            }

            this.ProductTable.forEach(item => {
                if (item.BarCode == this.params.barcode) {
                    isValid = true;
                }
            });
            return isValid;
        },
        isValidProduct() {
            let isValid = false;
            if (this.params.barcode == "") {
                isValid = false;
            }

            this.order_items.forEach(item => {
                if (item.barcode == this.params.barcode) {
                    isValid = true;
                }
            });
            return isValid;
        },
        isOrderSuccess() {
            let isPickupSuccess = true;
			if (this.order_items == null) return false

            this.order_items.forEach(item => {
                if (item.pickup_need != null) {
                    isPickupSuccess = false;
                }
            });
            return isPickupSuccess;
        },
        handleLock() {
            //  check storage sleected
            if (this.params.storage_id == "") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            // check shipping provider
            //if(this.params.shipping_provider_id == ""){
            //	swal.fire({
            //		title: "Error",
            //		text: "กรุณาเลือกผู้จัดส่ง",
            //		icon: "error",
            //		confirmButtonClass: "btn btn-danger btn-fill",
            //		buttonsStyling: false
            //	});
            //	return;
            //}

            this.lock = true;
            this.clearParam();
        },
        handleUnLock() {
            this.lock = false;
            this.clearParam();
        },
        clearParam() {
            this.order_items = [];
            this.pickup_items = [];
            this.params.id = "";
            this.params.shipping_provider_id = 0;
            this.params.tracking_number = "";
            this.params.barcode = "";
            this.barcode = "";
            this.state = 0;
        },
        GetProductImage(id) {
            // find product table
            let product = this.ProductTable.find(x => x.ID == id);
            if (product) {
                return (
                    process.env.VUE_APP_API_BASE_URL +
                    "/files/wms_products/" +
                    product.Image
                );
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped>
.el-table td {
    padding: 0 !important;
}
/* Packing room: a scanned product card gets a green frame; the green
   "all scanned" line sits above the cards (docs/specs/2026-10-06-packing-
   scanned-highlight-design.md P1/P3). Scoped, not in argon.scss: the shared
   theme is frozen by tests/unit/buttonDangerInk.spec.js. */
.packing-item--scanned {
    border: 2px solid #2dce89;
    background: rgba(45, 206, 137, .08);
}
.packing-all-scanned {
    font-size: 1.1rem;
    margin-bottom: .75rem;
    /* P3a: stand out by the band, not the text colour (text-success stays). */
    background: rgba(45, 206, 137, 0.15);
    border-left: 4px solid #2dce89;
    padding: 0.5rem 0.75rem;
    border-radius: 0.25rem;
}
/* P7b (spec §6): the theme pins .main-content .container-fluid padding to 30px
   !important (core/content/_main-content.scss), so utility classes cannot
   shrink the gap between the two cards. Narrow only the inner sides; the outer
   sides keep 30px so the left card does not touch the sidebar. */
.main-content .container-fluid.packing-col-left {
    padding-right: .5rem !important;
}
.main-content .container-fluid.packing-col-right {
    padding-left: .5rem !important;
}
/* P7 (spec §6): equal-height cards, images keep their ratio, smaller name. */
.packing-item__img {
    height: 140px;
    width: 100%;
    object-fit: contain;
    padding: .5rem .5rem 0;
}
.packing-item__name {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.3;
}
.packing-item__barcode {
    font-size: .9rem;
}
</style>
